import { FlowBasic } from '../types/Flow';
import { IDataConnection } from '../types/IDataConnection';
import { IBasicDataSource } from '../types/IDataSource';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDataConnectionsParams extends IGetItemsParams {
}

export interface IGetDataConnectionsResult extends IGetItemsResult {
  dataConnections?: IDataConnection[];
  datasources?: IBasicDataSource[];
  readonly flows?: ReadonlyArray<FlowBasic>;
  projects?: INamedItem[];
  users?: IUser[];
  workbooks?: INamedItem[];
}

export class GetDataConnectionsRequest extends Request<IGetDataConnectionsParams, IGetDataConnectionsResult> {
  constructor(params: IGetDataConnectionsParams) {
    super('getDataConnections', params);
  }
}
